/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { ONLINE_STATUS_UPDATE } from './actionTypes';

export const updateOnlineStatus = (isOnline) => ({
  type: ONLINE_STATUS_UPDATE,
  payload: {
    isOnline,
  },
});
